import {useEffect} from 'react';
import {useEnhancedRef} from './useEnhancedRef';

export type UseRequestAnimationFrameOptions = {
	disabled?: boolean;
};

export const useRequestAnimationFrame = (
	cb: () => void,
	{disabled}: UseRequestAnimationFrameOptions = {},
) => {
	const [cbRef] = useEnhancedRef(cb);

	useEffect(() => {
		if (disabled) return;

		let enabled = !disabled;
		const draw = () =>
			window.requestAnimationFrame(() => {
				if (!enabled) return;
				cbRef.current();
				draw();
			});

		draw();

		return () => {
			enabled = false;
		};
	}, [disabled]);
};

export default useRequestAnimationFrame;
